import React from 'react';
import * as Yup from 'yup';

export const feedbackSchema = Yup.object({
  rating: Yup.number(),
  comment: Yup.string().required('Comentário é obrigatório'),
});
